import { render, staticRenderFns } from "./iconSetting.vue?vue&type=template&id=6ee0c3ea&scoped=true&"
import script from "./iconSetting.vue?vue&type=script&lang=js&"
export * from "./iconSetting.vue?vue&type=script&lang=js&"
import style0 from "./iconSetting.vue?vue&type=style&index=0&id=6ee0c3ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee0c3ea",
  null
  
)

export default component.exports